import { Injectable } from '@angular/core';
import { Credentials } from '../types/credentials';
import { AwsApiService } from './aws-api.service';
import { LogService } from './log.service';
import { RouterService } from './router.service';
import { AWSError } from 'aws-sdk';
import { Organization } from '../types/organization';
import { IWorkflow } from '../interfaces/IWorkflow';
import { SpinnerService } from './spinner.service';
import { Workflow } from '../types/workflow';
import { PasswordService } from './password.service';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService implements IWorkflow {
  private username: string;
  private organization: Organization;
  private workflow: Workflow;

  constructor(
    private log: LogService,
    private spinner: SpinnerService,
    private router: RouterService,
    private passwordService: PasswordService
  ) {
    this.workflow = new Workflow('ForgotPassword', this.log);
  }

  isInProgress(): boolean {
    return this.workflow.isInProgress();
  }

  getUsernameInProgress(): string {
    return this.username;
  }

  reset() {
    this.workflow.end();
    this.username = null;
    this.organization = null;
  }

  forgotPassword(username: string, onAwsError: Function) {
    this.spinner.showSpinner();

    this.username = username;
    this.workflow.start();

    this.passwordService.forgotPassword(username, (err, data) => {
      this.spinner.hideSpinner();

      if (err) {
        this.reset();
        onAwsError(err);
      } else {
        this.log.trace('success', data);
        this.router.gotoForgotPasswordConfirm();
      }
    });
  }

  confirmForgotPassword(
    code: string,
    new_password: string,
    username?: string,
    callback?: Function
  ) {
    this.spinner.showSpinner();

    this.passwordService.confirmForgotPassword(
      username || this.username,
      code,
      new_password,
      (err, data) => {
        this.spinner.hideSpinner();
        callback(err, data);
      }
    );
  }
}
